<template>
  <div class="static-page" :style="pageStyle" v-if="pageExist">
    <div class="custom-background">
      <video class="custom-page__video"
             v-if="page.custom_video_bg"
             :src="getImagePath(page.custom_video_bg)"
             type="video/mp4"
             autoplay
             loop
             muted
      />
      <image-component
        class="custom-page__image"
        v-else-if="page.custom_image_bg"
        :path="page.custom_image_bg"
      />
    </div>
    <div class="custom-content max-content-wrapper">
      <div
        class="text-left mt-5 ml-5 mr-5"
        v-html="pageContent"
      />
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import ImageComponent from '../components/base-components/ImageComponent';
import * as ACTION from '@/store/actionTypes';
import Vue from 'vue';

const defaultPageData = {
  custom_video_bg: null,
  custom_image_bg: null,
  custom_bg_color: null,
};

export default {
  name: 'CustomPageScreen',
  components: {ImageComponent},
  data() {
    return {
      pageExist: false,
      page: {...defaultPageData},
    };
  },
  watch: {
    $route() {
      this.getPageContent();
    },
  },
  computed: {
    pageStyle() {
      if (!this.page.custom_video_bg && !this.page.custom_image_bg) {
        return {
          backgroundColor: this.page.custom_bg_color,
        };
      }
      return {};
    },
    pageContent() {
      const content = this.page?.content_lang?.[Vue.i18n.locale()] || this.page?.content;
      return this.convertEditorJsonToHtml(content);
    },
  },
  methods: {
    ...mapActions({getChannelPage: ACTION.GET_CHANNEL_PAGE}),
    getPageContent() {
      this.getChannelPage(this.$route.meta.id)
          .then((data) => {
            this.pageExist = true;
            this.page = data.data;
          }).catch(() => {
            this.pageExist = false;
            this.page = {...defaultPageData};
          });
    },
  },
  created() {
    this.getPageContent();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/colors";

.custom-page__video,
.custom-page__image {
  opacity: 0.25;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.custom-content{
  position: relative;
  flex-grow: 1;
  z-index: 2;
  overflow-y: auto;
}
.custom-background{
  position: absolute;
  flex-grow: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
.static-page {
  position: relative;
  font-weight: normal;
  font-style: normal;
  text-transform: none;
  display: flex;
  flex-direction: column;
}
</style>

